import UnicoUtils from './script-utils.js';

/**
 * 絞り込み検索エリア
 */
export default class SearchArea extends HTMLElement {
  constructor() {
    super();

    // 要素の取得
    this.form = this.querySelector('form');
    this.resetButton = this.querySelector('.unico-button-search-clear');
    this.filterButton = this.querySelector('.unico-button-search-filter');

    // イベントハンドラ
    this.resetButton.addEventListener('click', (e) => {
      this.resetHandler(e);
    });
    this.filterButton.addEventListener('click', (e) => {
      this.filterHandler(e);
    });

    // 初期表示処理
    this.init();
  }

  /**
   * 初期表示処理
   */
  init() {
    if (UnicoUtils.isPC()) {
      this.classList.add('-is-show');
    }
  }

  /**
   * 選択済みの検索条件を取得します。
   */
  getFormData() {
    // チェックされたチェックボックスと選択されたラジオボタンを取得
    const checkedCheckbox = this.querySelectorAll(
      'input[type="checkbox"]:checked',
    );
    const checkedRadioButton = this.querySelectorAll(
      'input[type="radio"]:checked',
    );

    const checkboxData = {};
    checkedCheckbox.forEach((checkbox) => {
      if (!checkboxData[checkbox.name]) {
        checkboxData[checkbox.name] = [];
      }
      checkboxData[checkbox.name].push(checkbox.value);
    });

    const radioData = {};
    checkedRadioButton.forEach((radio) => {
      radioData[radio.name] = [radio.value];
    });

    return { ...checkboxData, ...radioData };
  }

  /**
   * リセットボタン押下時の処理
   * @param e
   */
  resetHandler(e) {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    if (currentUrl.search.includes('q=')) {
      searchParams.append('q', currentUrl.searchParams.get('q'));
    }
    if (currentUrl.search.includes('filter.p.tag')) {
      searchParams.append(
        'filter.p.tag',
        currentUrl.searchParams.get('filter.p.tag'),
      );
    }
    for (let key in this.getFormData()) {
      searchParams.delete(key);
    }
    const newUrl =
      currentUrl.origin + currentUrl.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newUrl);
    this.sectionUpdateRender();
    if (UnicoUtils.isSP()) {
      document.dispatchEvent(new CustomEvent('search-area-close'));
    }
  }

  /**
   * 絞り込み実行時の処理
   * @param e
   */
  filterHandler(e) {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    if (currentUrl.search.includes('q=')) {
      searchParams.append('q', currentUrl.searchParams.get('q'));
    }
    if (currentUrl.search.includes('filter.p.tag')) {
      searchParams.append(
        'filter.p.tag',
        currentUrl.searchParams.get('filter.p.tag'),
      );
    }
    for (let key in this.getFormData()) {
      searchParams.delete(key);
      this.getFormData()[key].forEach((value) => {
        searchParams.append(key, value);
      });
    }

    // 絞り込み検索エリアを閉じる場合は、以下のイベントを発行する
    const newUrl =
      currentUrl.origin + currentUrl.pathname + '?' + searchParams.toString() + '&type=product';

    history.pushState(null, '', newUrl);
    this.sectionUpdateRender();
    if (UnicoUtils.isSP()) {
      document.dispatchEvent(new CustomEvent('search-area-close'));
    }
  }
  sectionUpdateRender() {
    return new Promise((resolve) => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.append('sections[]', this.dataset.id);
      searchParams.append(
        'section_url',
        location.origin + location.pathname + '?' + searchParams.toString(),
      );
      fetch(location.origin + location.pathname + '?' + searchParams.toString())
        .then((res) => res.json())
        .then((res) => {
          document.querySelector(`[data-id="${this.dataset.id}"]`).innerHTML =
            res[this.dataset.id];
          window.scrollTo(0, 0);
          document.querySelector('unico-collections-area').initSearchArea();
        });
    });
  }
}
